import { createSlice } from "@reduxjs/toolkit";

const accountingSlice = createSlice({
  name: "accountingTable",
  initialState: {
    accountingTable: [],
    accountingTableFilter: [],
  },

  reducers: {
    setAccountList: (state, action) => {
      state.accountingTable = action.payload.accountingData;
    },
    setAccountListFilter: (state, action) => {
      state.accountingTableFilter = action.payload.filterAccountData;
    },
  },
});

export const { setAccountList, setAccountListFilter } = accountingSlice.actions;

export default accountingSlice.reducer;
